import { ofType } from "redux-observable";
import { EMPTY, from } from "rxjs";
import { switchMap, switchMapTo } from "rxjs/operators";
import { selectIsPurchasePointsEventRunning, selectPurchasePointEventRemainingTime, } from "../../../selectors/selectPurchasePointsEventInfo";
import { utilTick } from "../../../utils/utilTick";
import { utilTime } from "../../../utils/utilTime";
import { TypeActionApp } from "../../app/actionApp";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionPurchasePointsHideHudButton } from "../../purchase-points-event/actionPurchasePointsEventInfo";
export var epicTimePurchasePointsEvent = function (action$, state$) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(utilTick.second$), switchMap(function () {
        var state = state$.value;
        var purchasePointsEventShouldDisplay = selectIsPurchasePointsEventRunning(state);
        var purchasePointEventRemainingTime = selectPurchasePointEventRemainingTime(state);
        if (purchasePointsEventShouldDisplay &&
            utilTime.secondsLeftTill(purchasePointEventRemainingTime) < 0) {
            return from([
                actionPurchasePointsHideHudButton(),
                actionModalClose(IdModal.PurchasePointsEvent),
            ]);
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimePurchasePointsEvent.ts
// module id = 2438
// module chunks = 3